import { useCallback, useState } from "react";

/** 仅读取当前确认件的开合偏好，存储受限时按默认收起处理。 */
function readDisclosure(key: string | null): boolean {
  if (!key || typeof window === "undefined") return false;
  try { return window.sessionStorage.getItem(key) === "true"; }
  catch { return false; }
}

/** 同一标签页刷新恢复核对提示开合；按工作区和导入批次隔离，不缓存业务报告。 */
export function useConfirmationReviewDisclosure(
  workspaceId: string | undefined,
  section: "overview" | "budget-import",
  reportIdentity = "",
) {
  const scope = JSON.stringify([workspaceId ?? "", section, reportIdentity]);
  const key = workspaceId ? `fulfillment-order:review-disclosure:${scope}` : null;
  const [state, setState] = useState(() => ({ scope, open: readDisclosure(key) }));
  const open = state.scope === scope ? state.open : readDisclosure(key);
  const setOpen = useCallback((next: boolean) => {
    setState({ scope, open: next });
    if (!key || typeof window === "undefined") return;
    try { window.sessionStorage.setItem(key, String(next)); }
    catch { /* 存储受限时仍保留当前页面的开合操作。 */ }
  }, [key, scope]);
  return [open, setOpen] as const;
}
